<div class="row mx-lg-0 py-1 icasino_tabs">
    <div class="col-md-6 col-6" [routerLink]="_common.getToken() ? ['/sports',99999] : ['/guest/sports',99999]">
        <div class="position-relative">
            <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/casino.png" />
            <span>Casino</span>
        </div>
    </div>
    <div class="col-md-6 col-6" [routerLink]="_common.getToken() ? ['/sports',99995] : ['/guest/sports',99995]">
        <div class="position-relative">
            <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icasino.png" />
            <span>I-Casino</span>
        </div>
    </div>
</div>